var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"switch"},[_c('input',{attrs:{"type":"checkbox"},domProps:{"value":_vm.modelValue,"checked":_vm.modelValue},on:{"change":_vm.handleChange}}),_c('span',{class:_vm.klass})])}
var staticRenderFns = []

export { render, staticRenderFns }